import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, flatMap, switchMap } from 'rxjs/operators';
import * as fromShared from '../../../shared';
import * as eFAACTCustomerActions from './efaact-customer.actions';
import { InternalAdminService } from '../../internal-admin.service';

@Injectable()
export class eFAACTCustomerEffects {
    constructor(
        private actions$: Actions,
        private service: InternalAdminService
    ) {}

    get$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(eFAACTCustomerActions.geteFAACTCustomer),
            switchMap(a =>
                this.service.geteFAACTCustomers().pipe(
                    flatMap(resp => [
                        eFAACTCustomerActions.loadeFAACTCustomers({
                            eFAACTCustomers: JSON.parse(resp)
                        })
                    ]),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });
}
